/**
 * Time in this system (Plan U, part 0; decided 28/09/2026): every instant is
 * stored in Vietnam time as 'YYYY-MM-DD HH:MM:SS' (defaults are
 * datetime('now', '+7 hours')), next to the wall-clock and calendar-day
 * columns that always were Vietnam time. These are the only conversions.
 * Vietnam has no daylight saving, so the offset is fixed.
 */
export const VN_OFFSET_MS = 7 * 60 * 60 * 1000;
export function vnIso(stored) {
    if (!stored)
        return null;
    const s = stored.replace(' ', 'T');
    return /[zZ]|[+-]\d\d:\d\d$/.test(s) ? s : `${s.length === 16 ? `${s}:00` : s}+07:00`;
}
/** Epoch milliseconds of a stored Vietnam time; NaN when unreadable. */
export const vnMs = (stored) => (stored ? Date.parse(vnIso(stored)) : NaN);
/** Now, as it is stored: '2026-10-01 19:05:00' in Vietnam time. */
export const vnStamp = (nowMs = Date.now()) => new Date(nowMs + VN_OFFSET_MS).toISOString().slice(0, 19).replace('T', ' ');
/** Today in Vietnam, 'YYYY-MM-DD'. */
export const vnDate = (nowMs = Date.now()) => vnStamp(nowMs).slice(0, 10);
/** Whole calendar days from a Vietnam date 'YYYY-MM-DD' to today in Vietnam (negative if it is in the future). */
export function vnDaysSince(day, nowMs = Date.now()) {
    const a = Date.parse(`${day.slice(0, 10)}T00:00:00Z`);
    const b = Date.parse(`${vnDate(nowMs)}T00:00:00Z`);
    return Math.round((b - a) / 86_400_000);
}
//# sourceMappingURL=time.js.map